import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import "../../assets/footer.scss";
import Text from "../text/Text";
import { setTransactionFilterData } from "../../redux/actions";
import {
  walletIcon,
  walletIconFill,
  settingsIcon,
  settingsIconFill,
  historyIcon,
  historyIconFill,
  appIcon,
  appIconFill,
} from "../images";

const featuresArray = [
  {
    id: "wallet",
    icon: <img src={walletIcon} height={26} width={26} alt="wallet icon" />,
    selectedIcon: (
      <img src={walletIconFill} height={26} width={26} alt="wallet icon" />
    ),
    text: "Wallet",
  },
  {
    id: "apps",
    icon: <img src={appIcon} height={26} width={26} alt="app icon" />,
    selectedIcon: (
      <img src={appIconFill} height={26} width={26} alt="app icon" />
    ),
    text: "Apps",
  },
  {
    id: "history",
    icon: <img src={historyIcon} height={26} width={26} alt="history icon" />,
    selectedIcon: (
      <img src={historyIconFill} height={26} width={26} alt="history icon" />
    ),
    text: "History",
  },
  {
    id: "settings",
    icon: <img src={settingsIcon} height={26} width={26} alt="settings icon" />,
    selectedIcon: (
      <img src={settingsIconFill} height={26} width={26} alt="settings icon" />
    ),
    text: "Settings",
  },
];

function OptionsFooter() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("dashboard");

  useEffect(() => {
    setSelectedTab(location?.pathname?.split("/")[1]);
  }, [location?.pathname]);

  const handleAction = (id) => {
    setSelectedTab(id);
    dispatch(setTransactionFilterData({}));
    navigate(`/${id}`);
  };

  return (
    <Box className="bottom-menu">
      {featuresArray.map((feature) => {
        return (
          <Box
            className={`feature ${
              feature?.id === selectedTab && "selected-feature"
            }`}
            onClick={() => handleAction(feature?.id)}
            key={feature?.id}
          >
            {feature?.id === selectedTab ? feature.selectedIcon : feature.icon}
            <Text
              sx={{
                color: feature?.id === selectedTab ? "#041F61" : "#848B9E",
              }}
              size={14}
              font="medium"
            >
              {feature.text}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
}

export default OptionsFooter;
